import React, { FC, useEffect, useState } from "react";
import { InfoOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import { RichTextBox } from "@components/common";
import { Box, Stack, Typography, Tooltip } from "@components/base";
import { useQuestionEditorStore } from "@components/main/questions/QuestionEditor";

const Description: FC = () => {
  const { language, newQuestionConfig, setNewQuestionConfig } =
    useQuestionEditorStore();
  const { t } = useTranslation();
  const [descriptionText, setDescriptionText] = useState("");

  const handleChange = (value: string): void => {
    setDescriptionText(value);

    if (newQuestionConfig) {
      const newTranslations = newQuestionConfig.translations.map((translation) => {
        if (translation.language === language) {
          return { ...translation, description: value };
        }

        return translation;
      });

      setNewQuestionConfig({
        ...newQuestionConfig,
        translations: newTranslations,
      });
    }
  };

  useEffect(() => {
    const currentTranslation = newQuestionConfig?.translations.find(
      (translation) => translation.language === language,
    );

    if (currentTranslation) {
      setDescriptionText(currentTranslation.description || "");
    }
  }, [newQuestionConfig]);

  return (
    <Box sx={{ marginTop: 3 }}>
      <Stack direction="row" alignItems="center" mb={1} spacing={0.5}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {t("description.label")}
        </Typography>
        <Tooltip title={t("description.tooltip")}>
          <InfoOutlined
            sx={({ palette }) => ({
              color: palette.grey[400],
              fontSize: "1rem",
            })}
          />
        </Tooltip>
      </Stack>
      <RichTextBox value={descriptionText} onChange={handleChange} />
    </Box>
  );
};

export default Description;
